import React, { Component } from 'react';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization';

class NotificationUserActiveEmailModal extends Component {
  render() {
    const { activeEmailUpdate, closeActiveEmail } = this.props;
    const { isOpenDialog, email, title } = activeEmailUpdate;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          onRequestClose={closeActiveEmail}
          className="edit-merchant-form"
          width="600px"
        >
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            <div style={{ textAlign: 'center' }}>
              {trans('merchant_wallet_user_update_active_email_message')}
              <br />
              <b>
                <span style={{ color: '#EE4D2D' }}>{email}</span>
              </b>
              <br />
              {trans(
                'merchant_wallet_user_update_active_email_message_please_check_email',
              )}{' '}
              <br />
              <b style={{ color: '#EE4D2D' }}>
                {trans(
                  'merchant_wallet_user_update_active_email_message_inbox',
                )}
                .
              </b>
            </div>
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeActiveEmail}>
              {trans('common_close')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default NotificationUserActiveEmailModal;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/components/NotificationUserActiveEmailModal.jsx